import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { baseurl } from "../../baseurl";
import Swal from "sweetalert2";
import { FiHeart } from "react-icons/fi";
import NavigateHome from "../../component/utils/NavigateHome";
import PageCount from "../../component/utils/PageCount";
import FooterTwo from "../../component/FooterTwo";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  customClass: { popup: "swal2-toast-custom" },
});

function ReligionDetail() {
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    religion: "",
    sect: "",
    caste: "",
    motherTongue: "",
    fatherProfessionStatus: "",
    fatherProfession: "",
    motherProfessionStatus: "",
    motherProfession: "",
    numberOfSiblings: "",
    marriedSiblings: "",
  });

  const token = localStorage.getItem("token");

  // -----------------------------
  // RELIGION OPTIONS
  // -----------------------------
  const religionOptions = [
  { value: "hindu", label: "Hindu" },
  { value: "muslim", label: "Muslim" },
  { value: "christian", label: "Christian" },
  { value: "sikh", label: "Sikh" },
  { value: "buddhist", label: "Buddhist" },
  { value: "jain", label: "Jain" },
  { value: "zoroastrian", label: "Zoroastrian / Parsi" },
  { value: "jewish", label: "Jewish" },
  { value: "baha-i", label: "Baha'i" },
  { value: "tribal", label: "Tribal / Adivasi" },
  { value: "animism", label: "Animism / Nature Worship" },
  { value: "neo-buddhist", label: "Neo Buddhist / Navayana" },
  { value: "lingayat", label: "Lingayat" },
  { value: "ravidassia", label: "Ravidassia" },
  { value: "kabirpanthi", label: "Kabir Panthi" },
  { value: "sanamahism", label: "Sanamahism (Manipur)" },
  { value: "sarna", label: "Sarna (Jharkhand)" },
  { value: "doniyopolo", label: "Donyi-Polo (Arunachal Pradesh)" },
  { value: "other", label: "Other" },
];


  // -----------------------------
  // DEPENDENT SECT OPTIONS
  // -----------------------------
 const sectMap = {
  // -------------------------
  // HINDU SECTS / CASTES
  // -------------------------
  hindu: [
    { value: "brahmin", label: "Brahmin" },
    { value: "kshatriya", label: "Kshatriya" },
    { value: "vaishya", label: "Vaishya" },
    { value: "shudra", label: "Shudra" },

    // Major caste groups
    { value: "agarwal", label: "Agarwal" },
    { value: "gupta", label: "Gupta" },
    { value: "rajput", label: "Rajput" },
    { value: "maratha", label: "Maratha" },
    { value: "reddy", label: "Reddy" },
    { value: "kamma", label: "Kamma" },
    { value: "kapu", label: "Kapu" },
    { value: "kurmi", label: "Kurmi" },
    { value: "yadav", label: "Yadav" },
    { value: "lingayat", label: "Lingayat" },
    { value: "kayastha", label: "Kayastha" },
    { value: "bania", label: "Bania" },
    { value: "mahar", label: "Mahar" },
    { value: "nai", label: "Nai" },
    { value: "sonar", label: "Sonar" },
    { value: "teli", label: "Teli" },
    { value: "koli", label: "Koli" },
    { value: "vishwakarma", label: "Vishwakarma" },
    { value: "brahmin-iyer", label: "Brahmin Iyer" },
    { value: "brahmin-iyengar", label: "Brahmin Iyengar" },
    { value: "brahmin-chitpavan", label: "Brahmin Chitpavan" },
    { value: "brahmin-gurukkal", label: "Brahmin Gurukkal" },
    { value: "brahmin-kanyakubj", label: "Brahmin Kanyakubj" },
    { value: "kayastha-bengali", label: "Bengali Kayastha" },
    { value: "brahmin-bengali", label: "Bengali Brahmin" },
    { value: "maithil-brahmin", label: "Maithil Brahmin" },
    { value: "kannada-gowda", label: "Vokkaliga / Gowda" },

    { value: "other", label: "Other" }
  ],

  // -------------------------
  // MUSLIM SECTS
  // -------------------------
  muslim: [
    { value: "sunni", label: "Sunni" },
    { value: "shia", label: "Shia" },
    { value: "bohra", label: "Dawoodi Bohra" },
    { value: "ismaili", label: "Ismaili" },
    { value: "ahmadiyya", label: "Ahmadiyya" },
    { value: "sufi", label: "Sufi" },
    { value: "memon", label: "Memon" },
    { value: "ansari", label: "Ansari" },
    { value: "pathan", label: "Pathan" },
    { value: "qureshi", label: "Qureshi" },
    { value: "saifi", label: "Saifi" },
    { value: "general", label: "General" }
  ],

  // -------------------------
  // CHRISTIAN SECTS
  // -------------------------
  christian: [
    { value: "catholic", label: "Catholic" },
    { value: "roman-catholic", label: "Roman Catholic" },
    { value: "protestant", label: "Protestant" },
    { value: "orthodox", label: "Orthodox" },
    { value: "pentecostal", label: "Pentecostal" },
    { value: "born-again", label: "Born Again" },
    { value: "marthoma", label: "Marthoma" },
    { value: "syrian-christian", label: "Syrian Christian" },
    { value: "other", label: "Other" }
  ],

  // -------------------------
  // SIKH COMMUNITIES
  // -------------------------
  sikh: [
    { value: "jat", label: "Jat Sikh" },
    { value: "ramgarhia", label: "Ramgarhia" },
    { value: "arora", label: "Arora" },
    { value: "khatri", label: "Khatri" },
    { value: "labana", label: "Labana" },
    { value: "rajput-sikh", label: "Rajput Sikh" },
    { value: "mazhabi", label: "Mazhabi" },
    { value: "ramdasia", label: "Ramdasia" },
    { value: "other", label: "Other" }
  ],

  // -------------------------
  // BUDDHIST GROUPS
  // -------------------------
  buddhist: [
    { value: "theravada", label: "Theravada" },
    { value: "mahayana", label: "Mahayana" },
    { value: "vajrayana", label: "Vajrayana" },
    { value: "navayana", label: "Navayana / Neo Buddhist" },
    { value: "tibetan", label: "Tibetan Buddhist" },
    { value: "other", label: "Other" }
  ],

  // -------------------------
  // JAIN SECTS
  // -------------------------
  jain: [
    { value: "digambar", label: "Digambar" },
    { value: "shwetambar", label: "Shwetambar" },
    { value: "stanakvasi", label: "Sthanakvasi" },
    { value: "terapanthi", label: "Terapanthi" },
    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // PARSI / ZOROASTRIAN
  // -----------------------------
  "zoroastrian": [
    { value: "parsi", label: "Parsi" },
    { value: "irani", label: "Irani" },
    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // JEWISH
  // -----------------------------
  jewish: [
    { value: "bene-israel", label: "Bene Israel" },
    { value: "cochin-jew", label: "Cochin Jew" },
    { value: "baghdadi-jew", label: "Baghdadi Jew" },
    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // Baha'i
  // -----------------------------
  "baha-i": [
    { value: "general", label: "General" }
  ],

  // -----------------------------
  // Tribal / Adivasi
  // -----------------------------
  tribal: [
    { value: "gond", label: "Gond" },
    { value: "santal", label: "Santal" },
    { value: "oraon", label: "Oraon" },
    { value: "munda", label: "Munda" },
    { value: "bhil", label: "Bhil" },
    { value: "ho", label: "Ho" },
    { value: "kharia", label: "Kharia" },
    { value: "dimasa", label: "Dimasa" },
    { value: "karbi", label: "Karbi" },
    { value: "bodo", label: "Bodo" },
    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // Animism
  // -----------------------------
  animism: [
    { value: "nature-worshipper", label: "Nature Worshipper" },
    { value: "other", label: "Other" }
  ],

  "neo-buddhist": [
    { value: "navayana", label: "Navayana" }
  ],

  lingayat: [
    { value: "lingayat", label: "Lingayat" },
    { value: "veerashaiva", label: "Veerashaiva" }
  ],

  ravidassia: [
    { value: "ravidassia", label: "Ravidassia" }
  ],

  kabirpanthi: [
    { value: "kabirpanthi", label: "Kabir Panthi" }
  ],

  sanamahism: [
    { value: "meitei", label: "Meitei" }
  ],

  sarna: [
    { value: "sarna", label: "Sarna Dharma" }
  ],

  doniyopolo: [
    { value: "ani", label: "Adi / Ani" },
    { value: "apatani", label: "Apatani" },
    { value: "nyishi", label: "Nyishi" },
    { value: "other", label: "Other" }
  ],

  other: [{ value: "general", label: "General" }]
};

  // -----------------------------
  // DEPENDENT CASTE OPTIONS
  // -----------------------------
  const casteMap = {
  // -----------------------------
  // HINDU CASTES
  // -----------------------------
  hindu: [
    // Major Varna groups
    { value: "brahmin", label: "Brahmin" },
    { value: "kshatriya", label: "Kshatriya" },
    { value: "vaishya", label: "Vaishya" },
    { value: "shudra", label: "Shudra" },

    // Brahmin groups
    { value: "iyer", label: "Brahmin Iyer" },
    { value: "iyengar", label: "Brahmin Iyengar" },
    { value: "gawli-brahmin", label: "Gawli Brahmin" },
    { value: "saraswat", label: "Saraswat Brahmin" },
    { value: "chitpavan", label: "Chitpavan Brahmin" },
    { value: "kanyakubja", label: "Kanyakubja Brahmin" },
    { value: "gour-brahmin", label: "Gour Brahmin" },
    { value: "kashmiri-pandit", label: "Kashmiri Pandit" },

    // Popular castes (India-wide)
    { value: "maratha", label: "Maratha" },
    { value: "rajput", label: "Rajput" },
    { value: "yadav", label: "Yadav" },
    { value: "kurmi", label: "Kurmi" },
    { value: "kayastha", label: "Kayastha" },
    { value: "agarwal", label: "Agarwal" },
    { value: "gupta", label: "Gupta" },
    { value: "sonar", label: "Sonar" },
    { value: "nai", label: "Nai" },
    { value: "teli", label: "Teli" },
    { value: "bania", label: "Bania" },
    { value: "koli", label: "Koli" },
    { value: "mahar", label: "Mahar" },
    { value: "gounder", label: "Gounder" },
    { value: "vanniyar", label: "Vanniyar" },
    { value: "reddy", label: "Reddy" },
    { value: "kapu", label: "Kapu" },
    { value: "kamma", label: "Kamma" },
    { value: "vishwakarma", label: "Vishwakarma" },
    { value: "lingayat", label: "Lingayat" },
    { value: "gowda", label: "Vokkaliga / Gowda" },

    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // MUSLIM CASTES (Biradari)
  // -----------------------------
  muslim: [
    // Ashraf (upper)
    { value: "syed", label: "Syed" },
    { value: "pathan", label: "Pathan" },
    { value: "shaikh", label: "Shaikh" },
    { value: "mughal", label: "Mughal" },

    // Ajlaf (middle)
    { value: "ansari", label: "Ansari" },
    { value: "memon", label: "Memon" },
    { value: "qureshi", label: "Qureshi" },
    { value: "saifi", label: "Saifi" },
    { value: "mansoori", label: "Mansoori" },

    // Arzal (lower)
    { value: "halalkhor", label: "Halalkhor" },
    { value: "laheri", label: "Laheri" },
    { value: "dhobi-muslim", label: "Dhobi Muslim" },

    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // CHRISTIAN CASTES (Mainly Kerala & Tamil Nadu)
  // -----------------------------
  christian: [
    { value: "roman-catholic", label: "Roman Catholic" },
    { value: "latin-catholic", label: "Latin Catholic" },
    { value: "syrian-catholic", label: "Syrian Catholic" },
    { value: "malankara", label: "Malankara Christian" },
    { value: "mar-thoma", label: "Marthoma" },
    { value: "protestant", label: "Protestant" },
    { value: "pentecostal", label: "Pentecostal" },
    { value: "orthodox", label: "Orthodox" },
    { value: "dalit-christian", label: "Dalit Christian" },
    { value: "nadar-christian", label: "Nadar Christian" },
    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // SIKH CASTES
  // -----------------------------
  sikh: [
    { value: "jat", label: "Jat Sikh" },
    { value: "ramgarhia", label: "Ramgarhia" },
    { value: "arora", label: "Arora Sikh" },
    { value: "khatri", label: "Khatri Sikh" },
    { value: "labana", label: "Labana Sikh" },
    { value: "mazhabi-sikh", label: "Mazhabi Sikh" },
    { value: "ramdasia", label: "Ramdasia" },
    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // BUDDHIST CASTES
  // -----------------------------
  buddhist: [
    { value: "nav-buddhist", label: "Navayana Buddhist" },
    { value: "mahar-buddhist", label: "Mahar Buddhist" },
    { value: "tibetan", label: "Tibetan Buddhist" },
    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // JAIN CASTES
  // -----------------------------
  jain: [
    { value: "digambar", label: "Digambar" },
    { value: "shwetambar", label: "Shwetambar" },
    { value: "oswal", label: "Oswal" },
    { value: "porwal", label: "Porwal" },
    { value: "agrahar", label: "Agrahar" },
    { value: "shrimal", label: "Shrimal" },
    { value: "terapanthi", label: "Terapanthi" },
    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // PARSI / ZOROASTRIAN
  // -----------------------------
  zoroastrian: [
    { value: "parsi", label: "Parsi" },
    { value: "irani", label: "Irani Parsi" },
    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // JEWISH
  // -----------------------------
  jewish: [
    { value: "bene-israel", label: "Bene Israel" },
    { value: "baghdadi", label: "Baghdadi Jew" },
    { value: "cochin-jew", label: "Cochin Jew" },
    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // Baha'i
  // -----------------------------
  "baha-i": [{ value: "general", label: "General" }],

  // -----------------------------
  // Tribal / Adivasi
  // -----------------------------
  tribal: [
    { value: "gond", label: "Gond" },
    { value: "santal", label: "Santal" },
    { value: "munda", label: "Munda" },
    { value: "oraon", label: "Oraon" },
    { value: "bodo", label: "Bodo" },
    { value: "bhil", label: "Bhil" },
    { value: "ho", label: "Ho" },
    { value: "kharia", label: "Kharia" },
    { value: "dimasa", label: "Dimasa" },
    { value: "nikobari", label: "Nicobarese" },
    { value: "other", label: "Other" }
  ],

  // -----------------------------
  // Animism / Nature Worship
  // -----------------------------
  animism: [
    { value: "nature", label: "Nature Worshipper" },
    { value: "sarhul", label: "Sarhul" },
    { value: "other", label: "Other" }
  ],

  // Remaining categories
  "neo-buddhist": [{ value: "navayana", label: "Navayana" }],
  lingayat: [{ value: "lingayat", label: "Lingayat" }],
  ravidassia: [{ value: "ravidassia", label: "Ravidassia" }],
  kabirpanthi: [{ value: "kabirpanthi", label: "Kabir Panthi" }],
  sanamahism: [{ value: "meitei", label: "Meitei" }],
  sarna: [{ value: "sarna", label: "Sarna Dharma" }],
  doniyopolo: [
    { value: "adi", label: "Adi Tribe" },
    { value: "apatani", label: "Apatani" },
    { value: "nyishi", label: "Nyishi" },
    { value: "other", label: "Other" }
  ],

  other: [{ value: "general", label: "General" }]
};

  // Mother Tongue
  const motherTongueOptions = [
  // Major Indian Languages
  { value: "hindi", label: "Hindi" },
  { value: "marathi", label: "Marathi" },
  { value: "bengali", label: "Bengali" },
  { value: "telugu", label: "Telugu" },
  { value: "tamil", label: "Tamil" },
  { value: "gujarati", label: "Gujarati" },
  { value: "punjabi", label: "Punjabi" },
  { value: "urdu", label: "Urdu" },
  { value: "kannada", label: "Kannada" },
  { value: "malayalam", label: "Malayalam" },
  { value: "odia", label: "Odia" },
  { value: "assamese", label: "Assamese" },
  { value: "kashmiri", label: "Kashmiri" },
  { value: "konkani", label: "Konkani" },
  { value: "sindhi", label: "Sindhi" },
  { value: "sanskrit", label: "Sanskrit" },
  { value: "manipuri", label: "Manipuri / Meitei" },
  { value: "nepali", label: "Nepali" },
  { value: "bodo", label: "Bodo" },
  { value: "dogri", label: "Dogri" },
  { value: "santali", label: "Santali" },
  { value: "maithili", label: "Maithili" },

  // Other Major Regional Language Groups
  { value: "rajasthani", label: "Rajasthani" },
  { value: "haryanvi", label: "Haryanvi" },
  { value: "bhili", label: "Bhili" },
  { value: "garhwali", label: "Garhwali" },
  { value: "kumouni", label: "Kumaoni" },
  { value: "magahi", label: "Magahi" },
  { value: "bhojpuri", label: "Bhojpuri" },
  { value: "chhattisgarhi", label: "Chhattisgarhi" },
  { value: "tulu", label: "Tulu" },
  { value: "sourashtra", label: "Sourashtra" },
  { value: "mizo", label: "Mizo" },
  { value: "khasi", label: "Khasi" },
  { value: "gharo", label: "Garo" },
  { value: "kokborok", label: "Kokborok (Tripura)" },

  // Tribal & Regional Languages
  { value: "gondi", label: "Gondi" },
  { value: "ho", label: "Ho" },
  { value: "munda", label: "Munda" },
  { value: "kurukh", label: "Kurukh / Oraon" },
  { value: "kharia", label: "Kharia" },
  { value: "lepcha", label: "Lepcha" },
  { value: "nicobarese", label: "Nicobarese" },

  { value: "other", label: "Other" }
];


  // Profession Status
  const professionStatusOptions = [
    { value: "working", label: "Working" },
    { value: "business", label: "Business" },
    { value: "retired", label: "Retired" },
    { value: "not-working", label: "Not Working" },
    { value: "passed-away", label: "Passed Away" },
  ];

  // NEW — Occupation List
const occupationOptions = [
  // Education
  { value: "teacher", label: "Teacher" },
  { value: "professor", label: "Professor" },
  { value: "tutor", label: "Tutor" },
  { value: "lecturer", label: "Lecturer" },

  // Healthcare
  { value: "doctor", label: "Doctor" },
  { value: "nurse", label: "Nurse" },
  { value: "pharmacist", label: "Pharmacist" },
  { value: "therapist", label: "Therapist" },
  { value: "lab-technician", label: "Lab Technician" },
  { value: "medical-researcher", label: "Medical Researcher" },

  // Engineering & IT
  { value: "engineer", label: "Engineer" },
  { value: "software-developer", label: "Software Developer" },
  { value: "data-analyst", label: "Data Analyst" },
  { value: "network-engineer", label: "Network Engineer" },
  { value: "civil-engineer", label: "Civil Engineer" },
  { value: "mechanical-engineer", label: "Mechanical Engineer" },
  { value: "electrical-engineer", label: "Electrical Engineer" },

  // Law & Administration
  { value: "lawyer", label: "Lawyer" },
  { value: "judge", label: "Judge" },
  { value: "advocate", label: "Advocate" },
  { value: "government-officer", label: "Government Officer" },
  { value: "bureaucrat", label: "Bureaucrat" },

  // Business & Finance
  { value: "business", label: "Business" },
  { value: "entrepreneur", label: "Entrepreneur" },
  { value: "accountant", label: "Accountant" },
  { value: "banker", label: "Banker" },
  { value: "financial-analyst", label: "Financial Analyst" },
  { value: "stock-broker", label: "Stock Broker" },

  // Private sector
  { value: "private-job", label: "Private Job" },
  { value: "manager", label: "Manager" },
  { value: "team-lead", label: "Team Lead" },
  { value: "hr", label: "HR Professional" },
  { value: "marketing", label: "Marketing / Sales" },

  // Science & Research
  { value: "scientist", label: "Scientist" },
  { value: "researcher", label: "Researcher" },
  { value: "lab-assistant", label: "Lab Assistant" },

  // Arts & Media
  { value: "artist", label: "Artist" },
  { value: "writer", label: "Writer / Author" },
  { value: "journalist", label: "Journalist" },
  { value: "actor", label: "Actor / Actress" },
  { value: "singer", label: "Singer" },
  { value: "dancer", label: "Dancer" },
  { value: "photographer", label: "Photographer" },

  // Agriculture & Skilled Trades
  { value: "farmer", label: "Farmer" },
  { value: "agriculture-worker", label: "Agriculture Worker" },
  { value: "carpenter", label: "Carpenter" },
  { value: "electrician", label: "Electrician" },
  { value: "plumber", label: "Plumber" },
  { value: "mechanic", label: "Mechanic" },
  { value: "driver", label: "Driver" },

  // Others
  { value: "social-worker", label: "Social Worker" },
  { value: "chef", label: "Chef / Cook" },
  { value: "law-enforcement", label: "Police / Law Enforcement" },
  { value: "military", label: "Military / Defense" },
  { value: "pilot", label: "Pilot" },
  { value: "travelling-professional", label: "Travelling Professional" },
  { value: "housewife", label: "Housewife" },
  { value: "retired", label: "Retired" },
  { value: "not-working", label: "Not Working" },
  { value: "other", label: "Other (Not in the list)" }
];


  // Fetch Saved Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${baseurl}getUserReligiousDetails`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = res.data.religious_details;

        setFormData({
          religion: data?.religion || "",
          sect: data?.sect || "",
          caste: data?.caste || "",
          motherTongue: data?.mother_tongue || "",
          fatherProfessionStatus: data?.father_profession_status || "",
          fatherProfession: data?.father_profession || "",
          motherProfessionStatus: data?.mother_profession_status || "",
          motherProfession: data?.mother_profession || "",
          numberOfSiblings: data?.number_of_siblings ?? "",
          marriedSiblings: data?.married_siblings ?? "",
        });
      } catch (err) {
        console.error("Error loading details:", err);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const getOption = (options, value) =>
    options.find((o) => o.value === value) || null;

  // Married Sibling options depend on numberOfSiblings
  const marriedSiblingOptions =
    formData.numberOfSiblings !== ""
      ? Array.from({ length: Number(formData.numberOfSiblings) + 1 }, (_, i) => ({
          value: i,
          label: i.toString(),
        }))
      : [];

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        religion: formData.religion,
        sect: formData.sect,
        caste: formData.caste,
        mother_tongue: formData.motherTongue,
        father_profession_status: formData.fatherProfessionStatus,
        father_profession: formData.fatherProfession,
        mother_profession_status: formData.motherProfessionStatus,
        mother_profession: formData.motherProfession,
        number_of_siblings: formData.numberOfSiblings,
        married_siblings: formData.marriedSiblings,
      };

      await axios.post(`${baseurl}updateUserReligiousDetails`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Toast.fire({ icon: "success", title: "Religious details saved!" });

      setTimeout(() => (window.location.href = "/partner-preference"), 700);
    } catch (err) {
      Toast.fire({
        icon: "error",
        title: err?.response?.data?.error || "Failed to update",
      });
    }
  };

  if (loading) return <p>Loading...</p>;

  return (

    <>
    <section className="profileinfo-section">
      <PageCount pageName = {"Religion Info"}/>
      <NavigateHome/>
      <div className="profileinfo-container">
        {/* <h2 className="text-center mb-4">Religious Details</h2> */}

<div className="basicinfo-header text-center mb-4">
                  <FiHeart className="header-icon" />
                  <h2>Religious Information</h2>
                  <p>
                    Let’s begin your journey with <b>Soulsathi.com</b> ❤️
                  </p>
                </div>


        <form className="profileinfo-form" onSubmit={handleSubmit}>
          <div className="row g-3">

            {/* Religion */}
            <div className="col-md-6">
              <label>Select Your Religion</label>
              <Select
                options={religionOptions}
                value={getOption(religionOptions, formData.religion)}
                onChange={(v) =>
                  setFormData({
                    ...formData,
                    religion: v.value,
                    sect: "",
                    caste: "",
                  })
                }
              />
            </div>

            {/* Dependent Sect */}
            <div className="col-md-6">
              <label>Select Your Sect</label>
              <Select
                options={sectMap[formData.religion] || []}
                value={getOption(sectMap[formData.religion] || [], formData.sect)}
                onChange={(v) => setFormData({ ...formData, sect: v.value })}
              />
            </div>

            {/* Dependent Caste */}
            <div className="col-md-6">
              <label>Select Your Caste</label>
              <Select
                options={casteMap[formData.religion] || []}
                value={getOption(casteMap[formData.religion] || [], formData.caste)}
                onChange={(v) => setFormData({ ...formData, caste: v.value })}
              />
            </div>

            {/* Mother Tongue */}
            <div className="col-md-6">
              <label>Mother Tongue</label>
              <Select
                options={motherTongueOptions}
                value={getOption(motherTongueOptions, formData.motherTongue)}
                onChange={(v) =>
                  setFormData({ ...formData, motherTongue: v.value })
                }
              />
            </div>

            {/* Father Status */}
            <div className="col-md-6">
              <label>Father's Status</label>
              <Select
                options={professionStatusOptions}
                value={getOption(
                  professionStatusOptions,
                  formData.fatherProfessionStatus
                )}
                onChange={(v) =>
                  setFormData({ ...formData, fatherProfessionStatus: v.value })
                }
              />
            </div>

            {/* Father Occupation */}
            <div className="col-md-6">
  <label>Father's Occupation</label>
  <Select
    options={occupationOptions.filter(opt => opt.value !== "housewife")}
    value={getOption(
      occupationOptions.filter(opt => opt.value !== "housewife"),
      formData.fatherProfession
    )}
    onChange={(v) =>
      setFormData({
        ...formData,
        fatherProfession: v.value,
      })
    }
  />
</div>


            {/* Mother Status */}
            <div className="col-md-6">
              <label>Mother's Status</label>
              <Select
                options={professionStatusOptions}
                value={getOption(
                  professionStatusOptions,
                  formData.motherProfessionStatus
                )}
                onChange={(v) =>
                  setFormData({ ...formData, motherProfessionStatus: v.value })
                }
              />
            </div>

            {/* Mother Occupation */}
            <div className="col-md-6">
              <label>Mother's Occupation</label>
              <Select
                options={occupationOptions}
                value={getOption(occupationOptions, formData.motherProfession)}
                onChange={(v) =>
                  setFormData({
                    ...formData,
                    motherProfession: v.value,
                  })
                }
              />
            </div>

            {/* Number of Siblings */}
            <div className="col-md-6">
              <label>Number of Siblings</label>
              <Select
                options={Array.from({ length: 11 }, (_, i) => ({
                  value: i,
                  label: i.toString(),
                }))}
                value={getOption(
                  Array.from({ length: 11 }, (_, i) => ({
                    value: i,
                    label: i.toString(),
                  })),
                  formData.numberOfSiblings
                )}
                onChange={(v) =>
                  setFormData({
                    ...formData,
                    numberOfSiblings: v.value,
                    marriedSiblings: "",
                  })
                }
              />
            </div>

            {/* Married Siblings (dependent) */}
            <div className="col-md-6">
              <label>How many are married?</label>
              <Select
                options={marriedSiblingOptions}
                value={getOption(
                  marriedSiblingOptions,
                  formData.marriedSiblings
                )}
                onChange={(v) =>
                  setFormData({
                    ...formData,
                    marriedSiblings: v.value,
                  })
                }
              />
            </div>
          </div>

          <div className="text-center mt-4">
            <button type="submit" className="btn-primary">
              Save & Continue →
            </button>
          </div>
        </form>
      </div>
    </section>


<FooterTwo />

    </>


  );
}

export default ReligionDetail;
